import { render } from "./ResourceContent.vue?vue&type=template&id=f1fdf1b6"
import script from "./ResourceContent.vue?vue&type=script&lang=js"
export * from "./ResourceContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__